var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.path === '/yrityslainahakemus')?_c('section',{staticClass:"section is-small"},[_c('div',{staticClass:"container"},[_c('loan-application')],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }